import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  getEmployeeById,
  uploadEmployeeDocuments,

} from "../../../api/employeeDocument";
import toast from "react-hot-toast";

const EmployeeDocuments = () => {
  const { id: paramId } = useParams();

  const [employeeId, setEmployeeId] = useState(paramId || "");
  const [employeeData, setEmployeeData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [documents, setDocuments] = useState({
    offerLetter: null,
    form16: null,
    relievingLetter: null,
    hikeLetter: null,
    payslip: null,
  });

  /* ================= FILE CHANGE ================= */

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];

    if (file && file.type !== "application/pdf") {
      toast.error("Only PDF files are allowed ❌");
      return;
    }

    setDocuments((prev) => ({
      ...prev,
      [name]: file,
    }));
  };

  /* ================= FETCH EMPLOYEE ================= */

  const fetchEmployee = async () => {
    if (!employeeId) {
      toast.error("Enter Employee ID ❌");
      return;
    }

    try {
      setLoading(true);

      const empRes = await getEmployeeById(employeeId);


      // ✅ FIX HERE
      setEmployeeData(empRes?.data || empRes || {});

      toast.success("Employee Loaded ✅");

    } catch (err) {
      setEmployeeData(null);
      toast.error("Employee Not Found ❌");
    } finally {
      setLoading(false);
    }
  };
  /* ================= VALIDATION ================= */

  const validate = () => {
    const newErrors = {};

    if (!employeeId.trim()) {
      newErrors.employeeId = "Employee ID is required";
    }

    if (Object.values(documents).every((doc) => !doc)) {
      newErrors.documents = "At least one document must be uploaded";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ================= SUBMIT ================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    if (!employeeData) {
      toast.error("Fetch employee first ❌");
      return;
    }

    try {
      const formData = new FormData();

      Object.keys(documents).forEach((key) => {
        if (documents[key]) {
          formData.append(key, documents[key]);
        }
      });

      await uploadEmployeeDocuments(employeeId, formData);

      toast.success("Documents Uploaded Successfully ✅");

      // ✅ Refresh documents after upload
      fetchEmployee();

      // ✅ Reset
      setDocuments({
        offerLetter: null,
        form16: null,
        relievingLetter: null,
        hikeLetter: null,
        payslip: null,
      });
    } catch (error) {
      toast.error("Upload Failed ❌");
    }
  };

  return (
    <div className="upload-container">
      <h2>Upload Employee Documents</h2>

      <form onSubmit={handleSubmit} className="upload-form">
        <div className="upload-group employee-search-row">

          {/* LEFT SIDE */}
          <div className="search-left">
            <label>Employee ID</label>

            <div className="search-box">
              <input
                type="text"
                value={employeeId}
                onChange={(e) => setEmployeeId(e.target.value)}
                placeholder="Enter Employee ID"
              />

              <button
                type="button"
                className="add-btn"
                onClick={fetchEmployee}
                disabled={loading}
              >
                {loading ? "Loading..." : "Search"}
              </button>
            </div>

            {errors.employeeId && (
              <p className="error-text">{errors.employeeId}</p>
            )}
          </div>

          {/* RIGHT SIDE 🔥 */}
          {employeeData && (
            <div className="search-right">
              <img
                src={employeeData.profileImage}
                alt="profile"
                className="search-emp-img"
              />

              <div className="emp-details">
                <h4>
                  {employeeData.firstName} {employeeData.lastName}
                </h4>

                <p><span>Designation:</span> {employeeData.designation}</p>
                <p><span>Email:</span> {employeeData.officialmailid}</p>
                <p><span>Phone:</span> {employeeData.mobilenumber}</p>
                <p><span>Location:</span> {employeeData.location}</p>
              </div>
            </div>
          )}

        </div>


        {/* ================= FILE UPLOAD ================= */}
        {["offerLetter", "form16", "relievingLetter", "hikeLetter", "payslip"].map(
          (field) => (
            <div className="upload-group" key={field}>
              <label>{field}</label>
              <input
                type="file"
                name={field}
                accept="application/pdf"
                onChange={handleFileChange}
              />
            </div>
          )
        )}

        {errors.documents && (
          <p style={{ color: "red" }}>{errors.documents}</p>
        )}

        <button type="submit" className="add-btn">
          Upload Documents
        </button>
      </form>
    </div>
  );
};

export default EmployeeDocuments;